import React from 'react';
import {Text, View, StyleSheet as PDFStyleSheet} from '@react-pdf/renderer';
import Activity from 'src/components/Resume/activity';

interface Props {
  school: string;
  gradYear?: number | string | null;
  gpa?: number | string | null;
  courses: string[];
  blackAndWhite?: boolean;
}

const EducationResumeSection = ({school, gradYear, gpa, courses, blackAndWhite}: Props) => {
  const styles = PDFStyleSheet.create({
    sectionHeader: {
      marginTop: 16,
      fontSize: 16,
      color: blackAndWhite ? 'black' : '#366aff',
    },
    coursesText: {
      width: '80%',
      fontSize: 11,
      fontWeight: 'normal',
      color: '#6a7886',
      marginTop: 4,
    },
    line: {
      marginBottom: 4,
      height: 1,
      backgroundColor: 'black',
    },
  });

  let schoolDescription = school;
  if (gpa) {
    schoolDescription += ' | Unweighted Raise Me GPA: ' + Number(gpa).toFixed(2);
  }

  return (
    <View>
      <Text style={styles.sectionHeader}>Education</Text>
      {blackAndWhite && <View style={styles.line} />}
      <Activity name={schoolDescription} date={'Class of ' + gradYear} />
      {courses.length > 0 && (
        <Text style={styles.coursesText}>{'Courses: ' + courses.join(', ')}</Text>
      )}
    </View>
  );
};

export default EducationResumeSection;
